import { Base, useResize } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Title class.
 */
export default class ParallaxMedia extends Base {
  breakpoints = ['2xs', 'xs', 's', 'm'];

  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'ParallaxMedia',
    refs: ['media'],
  };

  /**
   *
   */
  mounted() {
    gsap.set(this.$refs.media, { scale: 1.2, y: this.isMobile ? -20 : -100 });
    gsap.to(this.$refs.media, {
      y: this.isMobile ? 20 : 50,
      ease: 'none',
      scrollTrigger: {
        trigger: this.$el,
        start: 'top bottom',
        end: this.isMobile ? 'bottom top' : '+200% center',
        scrub: true,
        markers: false,
      },
    });
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(useResize().props().breakpoint);
  }
}
